import { ClickAwayListener, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";

import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import { useBotConfigStore } from "../../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { botInfoStore } from "../../../Store/Slices/socket/BotInfoSlice";
import { StyledNotificationBlockWrapper } from "../../Styles/StyledComponents";
import AppDrawer from "../UtilsComponents/AppDrawer";
import AppSmallButton from "../UtilsComponents/AppSmallButton";

interface Props {

}

const AppRenderNotificationMenu: React.FC<Props> = () => {
  const [open, setOpen] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [iconStyle, setIconStyle] = useState<number>(1);

  const fallbackImage = require("../../../assets/images/no_media_found.jpg");

  const { botConfig } = useSelector(useBotConfigStore);
  // Docked widgets sit pinned to a screen CORNER (right:0 anchors correctly
  // against the viewport there), but Expand centers the panel instead — see
  // StyledBotContainer's justify-content:center for surface==="expanded".
  // position:fixed measures from the viewport, not the panel, so right:0 on
  // Expand pinned the drawer to the viewport's right edge while the panel
  // itself sat in the middle — the drawer and the panel it belongs to were
  // no longer under each other at all. Centering the drawer the same way
  // (left:50% + translateX(-50%)) keeps it aligned with the panel on both
  // surfaces.
  const { isUserExpanded } = useSelector(botInfoStore);

  useEffect(() => {
    if (
      botConfig?.config?.notification_block?.enabled &&
      botConfig?.config?.notification_block?.data
    ) {
      setData(botConfig?.config?.notification_block?.data);
      setIconStyle(botConfig?.config?.notification_block?.selected_icon || 1);
    }
  }, [botConfig]);

  const handleCardClick = (url: any) => {
    window.open(url, "_blank", "noreferrer");
  };

  if (
    !botConfig?.config?.notification_block?.enabled ||
    botConfig?.config?.notification_block?.data?.length < 1
  ) {
    return null;
  }
  return (
    <>
      <StyledNotificationBlockWrapper>
        <IconButton
          onClick={() => setOpen(true)}
          className="notificationIcon"
        // style={{ pointerEvents: inputReadyStatus ? "auto" : "none" }}
        >
          {iconStyle === 1 && <NotificationsOutlinedIcon />}
          {iconStyle === 2 && <ConfirmationNumberIcon />}
          {iconStyle === 3 && <Inventory2OutlinedIcon />}
          {iconStyle === 4 && <MarkChatUnreadIcon />}
        </IconButton>

        <AppDrawer
          showDrawer={open}
          setShowDrawer={setOpen}
          style={{
            // position:fixed here is required against the CURRENTLY DEPLOYED
            // widget build, whose header still has overflow:hidden — a
            // position:absolute drawer gets clipped to nothing there (only
            // fixed escapes an ancestor's overflow:hidden). The local header
            // no longer clips (see the ::before note on StyledWidgetHeader),
            // so once that build is deployed this can go back to
            // position:absolute (no top/right needed, just left/right:0) —
            // fixed measures from the viewport instead of the panel, which is
            // why width has to be pinned to the panel's own size explicitly
            // instead of relying on left/right:0 the way absolute can.
            position: "fixed",
            top: "75px",
            // Docked is corner-pinned (right:0 against the viewport lines up
            // with the panel there); Expand centers the panel instead (see
            // StyledBotContainer's justify-content:center), so right:0 there
            // pinned the drawer to the viewport's own right edge while the
            // panel sat in the middle — centering the drawer the same way
            // (left:50%, offset back by -50% via the x prop below — Framer
            // Motion's animate.x would otherwise overwrite a transform set
            // here directly) keeps it under the panel on both surfaces.
            ...(isUserExpanded ? { left: "50%" } : { right: 0 }),
            width: "var(--geta-panel-width, 100%)",
            borderRadius: "6px",
            overflowX: "hidden",
            paddingBottom: 0,
          }}
          intialX={isUserExpanded ? "-50%" : 0}
          intialY={"5%"}
          animateX={isUserExpanded ? "-50%" : 0}
          animateY={0}
          exitX={isUserExpanded ? "-50%" : 0}
          exitY={"+100%"}
          // animateHeight sets the drawer's own height inline, so it takes
          // precedence over any bottom:0 in style above — 100% is the
          // panel's own remaining height below `top`, at any panel size.
          animateHeight={"calc(100% - 95px)"}
        >
          <ClickAwayListener onClickAway={() => setOpen(false)}>
            <div
              className="notificationListWrapper"
              style={{ overflow: "overlay", width: "100%" }}
            >
              {open &&
                data &&
                data?.length > 0 &&
                data?.map((curElem: any, index: number) => {
                  return (
                    <div
                      className={"singleRow"}
                      key={index?.toString()}
                      onClick={() => handleCardClick(curElem?.button_url)}
                    >
                      <div className="rowLeftBox">
                        <img src={curElem?.image?.source || fallbackImage} alt="" />
                      </div>

                      <div className="rowRightBox">
                        <div className="rowRightTop">
                          {curElem?.notification_title}
                        </div>
                        <div className="rowRightMiddle">
                          {curElem?.notification_description}
                        </div>
                        <div className="rowRightBottom" style={{}}>
                          <AppSmallButton
                            variant={"text"}
                            onClick={() => handleCardClick(curElem?.button_url)}
                            style={{ minWidth: "unset" }}
                          >
                            {curElem?.button_title}
                          </AppSmallButton>
                          <div className="footerText">
                            {curElem?.footer_text}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              <div className="staticButton" onClick={() => setOpen(false)}>
                <AppSmallButton
                  variant={"text"}
                  onClick={() => setOpen(false)}
                  style={{ width: "100%" }}
                >
                  Close
                </AppSmallButton>
              </div>
            </div>
          </ClickAwayListener>
        </AppDrawer>
      </StyledNotificationBlockWrapper>
    </>
  );
};

export default AppRenderNotificationMenu;
